import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { LoyaltyQrResponse, OCC_ENDPOINTS, OccBonusAvailable } from '@user/const';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccLoyaltyProgramService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadBonusBalance(): Observable<OccBonusAvailable> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.bonusBalance);

    const response = this.http.post<OccBonusAvailable>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.bonusBalance),
    });

    return response;
  }

  joinLoyaltyProgram(): Observable<void> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.joinLoyaltyProgram);

    const response = this.http.put<void>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.joinLoyaltyProgram),
    });

    return response;
  }

  getLoyaltyQr(): Observable<LoyaltyQrResponse> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.loyaltyQr);

    return this.http.get<LoyaltyQrResponse>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.loyaltyQr),
    });
  }

  getOldLoyaltyQr(): Observable<Pick<LoyaltyQrResponse, 'data'>> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.oldLoyaltyQr);

    return this.http.get<Pick<LoyaltyQrResponse, 'data'>>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.oldLoyaltyQr),
    });
  }
}
